import {axios as http} from "@/plugins/http"

export default class Api {
    static item(id, query) {
        let config = {
            params: query,
        }
        return http.get(`/api/v1/promocodes/shop/${id}`, config)
    }

    static items(query) {
        let config = {
            params: query,
        }
        return http.get("/api/v1/promocodes/shop", config)
    }

    static addLink(data) {
        return http.post("/api/v1/promocodes/shop/add-lnk-campaign", data)
    }

    static deleteLink(data) {
        return http.post("/api/v1/promocodes/shop/delete-lnk-campaign", data)
    }

    static statistic() {
        return http.get("/api/v1/promocodes/coupon/statistic");
    }

    static shops(query) {
        let config = {
            params: query,
        }
        return http.get("/api/v1/promocodes/shop", config);
    }

    static sources() {
        return http.get("/api/v1/promocodes/source")
    }

    static campaigns(query) {
        let config = {
            params: query,
        }
        return http.get("/api/v1/promocodes/campaign", config)
    }
}
